import axiosInstance from '../auth/axiosInstance';

/**
 * Create or update business value project
 * @param {Object} businessValueData - The business value project data
 * @returns {Promise<Object>} API response
 */
export const createOrUpdateBusinessValueProject = async (businessValueData) => {
  try {
    const { data } = await axiosInstance.post(
      '/CostEstimation/CreateOrUpdateBusinessValueProject',
      businessValueData
    );
    return data;
  } catch (error) {
    console.error('Error saving business value project:', error);
    throw error;
  }
};

/**
 * Get business value project by ID
 * @param {number} businessValueProjectId - The business value project ID
 * @returns {Promise<Object>} API response
 */
export const getBusinessValueProject = async (businessValueProjectId) => {
  try {
    const { data } = await axiosInstance.get(
      `/CostEstimation/GetBusinessValueProject/${businessValueProjectId}`
    );
    return data;
  } catch (error) {
    console.error('Error fetching business value project:', error);
    throw error;
  }
};

/**
 * Get all business value projects for a user with pagination
 * @param {number} userId - The user ID
 * @param {number} page - Page number (default: 1)
 * @param {number} pageSize - Number of items per page (default: 10)
 * @returns {Promise<Object>} API response
 */
export const getBusinessValueProjectsByUser = async (userId, page = 1, pageSize = 10) => {
  try {
    const { data } = await axiosInstance.get('/CostEstimation/GetBusinessValueProjects', {
      params: { userId, page, pageSize },
    });
    return data;
  } catch (error) {
    console.error('Error fetching business value projects:', error);
    throw error;
  }
};

/**
 * Get business value project detail by user ID and project ID
 * @param {number} userId - The user ID
 * @param {number} projectId - The project ID
 * @returns {Promise<Object>} API response
 */
export const getBusinessValueProjectDetail = async (userId, projectId) => {
  try {
    const { data } = await axiosInstance.get(
      `/CostEstimation/${userId}/GetBusinessValueProjectDetail/${projectId}`
    );
    console.log('API Response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching business value project detail:', error);
    throw error;
  }
};

/**
 * Delete business value project
 * @param {number} businessValueProjectId - The business value project ID
 * @returns {Promise<Object>} API response
 */
export const deleteBusinessValueProject = async (businessValueProjectId) => {
  try {
    const { data } = await axiosInstance.delete(
      `/CostEstimation/DeleteBusinessValueProject/${businessValueProjectId}`
    );
    return data;
  } catch (error) {
    console.error('Error deleting business value project:', error);
    throw error;
  }
};

/**
 * Calculate cash flow for business value project
 * @param {Object} cashFlowData - The cash flow calculation data
 * @returns {Promise<Object>} API response
 */
export const calculateCashFlow = async (cashFlowData) => {
  try {
    const { data } = await axiosInstance.post(
      '/CostEstimation/CalculateCashFlow',
      cashFlowData
    );
    return data;
  } catch (error) {
    console.error('Error calculating cash flow:', error);
    throw error;
  }
};
